/**
 * Get Available Serials Use Case
 *
 * This use case handles fetching available serials for a specific product
 * following clean architecture principles.
 *
 * @module GetAvailableSerialsUseCase
 */

import {DistributionRepository} from '../repository/DistributionRepository';
import {AvailableSerial} from '../models/distribution.model';

export class GetAvailableSerialsUseCase {
  constructor (private distributionRepository: DistributionRepository) {}

  async execute (productId: string): Promise<AvailableSerial[]> {
    try {
      // Business Logic Validation
      if (!productId || productId.trim() === '') {
        throw new Error('Product ID is required');
      }

      return await this.distributionRepository.getAvailableSerials(productId);
    } catch (error) {
      throw error;
    }
  }
}
